export const LOTTIE_PLAYER_VERSION = "2.0.2"; 
export const LOTTIE_WEB_VERSION = "^5.10.0";
